
<template>
  <div class="footerBox">
    <div class="indexFooterBoxW">
        <div class="indexFooterBox ">
          <div class="flex-start m-b-12">
            <div class="indexFooterBoxImage">
              <img src="https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/tangjiuhui/logo.png" />
            </div>
            <!-- <div>
              <p class="indexFooterBoxTitle">{{$t('homes.footerTitle1')}}</p>
              <img class="indexFooterBoxImg" :src="footerLogo1" />
            </div> -->
          </div>
          <!-- <div>
            <p class="indexFooterBoxTitle">{{$t('homes.footerTitle4')}}</p>
          </div> -->
        </div>
    </div>
    <div class="indexFooterBoxW">
      <div class="indexFooterBox ">
        <div class="indexFooterBox">
            <!-- <p class="indexFooterBoxTitle">{{$t('homes.footerTel')}}</p>
            <p class="indexFooterBoxTitle">{{$t('homes.footerFax')}}</p>
            <p class="indexFooterBoxTitle">{{$t('homes.footerEmail')}}</p>
            <p class="indexFooterBoxTitle">{{$t('homes.footerAddress')}}</p>
            <p class="indexFooterBoxTitle">
              <router-link to="/disclaimer" target="_blank"> {{ $t('aboutus2.aboutusH4_1') }}</router-link>
            </p> -->
            <p class="indexFooterBoxTitle">{{$t('homes.主办单位')}}</p>
            <!-- <p class="indexFooterBoxTitle">{{$t('homes.中华人民共和国科学技术部')}}</p>
            <p class="indexFooterBoxTitle">{{$t('homes.中华人民共和国国家知识产权局')}}</p>
            <p class="indexFooterBoxTitle">{{$t('homes.中国国际贸易促进委员会')}}</p> -->
            <p class="indexFooterBoxTitle">{{$t('homes.北京市人民政府')}}</p>
            <!-- <p class="indexFooterBoxTitle">
              <router-link to="/disclaimer" target="_blank"> {{ $t('aboutus2.aboutusH4_1') }}</router-link>
            </p> -->
        </div>
      </div>
    </div>

    <div class="indexFooterBoxW">
      <div class="indexFooterBox ">
        <div class="indexFooterBox">
          <div class="footShare flex-center">
            <!-- <a :href="$config.link.facebook.href" target="view_window" class="footerIcon1" v-if="$config.link.facebook.href"> -->
              <div class="footerIcon1">
                <div class="footerIcon-img">
                  <img :src="face" />
                </div>
              </div>
            <!-- </a> -->

            <!-- <a :href="$config.link.linkedin.href" target="view_window" class="footerIcon1" v-if="$config.link.linkedin.href"> -->
              <div class="footerIcon1">
                <div class="footerIcon-img">
                  <img :src="link" />
                </div>
              </div>
            <!-- </a> -->

            <!-- <a :href="$config.link.youtube.href" target="view_window" class="footerIcon1" v-if="$config.link.youtube.href"> -->
              <div class="footerIcon1">
                <div class="footerIcon-img">
                  <img :src="yt" />
                </div>
              </div>
            <!-- </a> -->

            <!-- <a :href="$config.link.twitter.href" target="view_window" class="footerIcon1" v-if="$config.link.twitter.href"> -->
              <div class="footerIcon1">
                <div class="footerIcon-img">
                  <img :src="tw" />
                </div>
              </div>
            <!-- </a> -->

          </div>
          <div class="text-center">
            <p class="indexFooterBoxTitle">{{$t('homes.footerTitle5')}}</p>
            <p class="indexFooterBoxTitle">{{$t('homes.footerTitle6')}}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="indexFooterBoxW">
      <div class="indexFooterBox flex-center align-start">
        <!-- <div class="footerIcon footerQRcode" v-if="$config.downApp">
          <div class="footerIconQR-img margin-b-8">
            <img src="https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/tangjiuhui/home/jinjiangmaocuhui.png" />
          </div>
          <div class="footerIconQR-P">
            <p>{{ $t('homes.晋江贸促会') }}</p>
            <p>{{ $t('homes.国际商会') }}</p>
            <p>{{ $t('homes.公众号') }}</p>
          </div>
        </div> -->

        <div class="footerIcon footerQRcode m-r-8" v-if="$config.downApp">
          <div class="footerIconQR-img margin-b-8">
            <img src="https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/tangjiuhui/home/downloadQRcode.png" />
          </div>
          <div class="footerIconQR-P">
            <p class="indexFooterBoxTitle">{{ $t('homes.download') }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import face from '@/assets/homeImages/face.png'
import link from '@/assets/homeImages/link.png'
import ins from '@/assets/homeImages/ins.png'
import pin from '@/assets/homeImages/pin.png'
import tw from '@/assets/homeImages/tw.png'
import wechat from '@/assets/homeImages/wechat.png'
import yt from '@/assets/homeImages/yt.png'
import downloadQRcode from '@/assets/homeImages/downloadQRcode.png'
import { mapGetters } from 'vuex'
import footerLogo from '@/assets/images/logo.png'
import footerLogo1 from '@/assets/images/footerLogo1.png'
import footerR from '@/assets/homeImages/footerR.png'

export default {
  props: {
    youMayLike: {
      type: [Object, String, Array],
      default: () => ''
    }
  },
  computed: {
    ...mapGetters(['language']),
  },
  data() {
    return {
      face: face,
      link: link,
      ins: ins,
      pin: pin,
      tw: tw,
      wechat: wechat,
      yt: yt,
      downloadQRcode: downloadQRcode,
      footerLogo:footerLogo,
      footerLogo1: footerLogo1,
      footerR:footerR
    }
  },
  mounted() {},
  methods: {}
}
</script>

<style lang="stylus" scoped>
.m-r-8{
  margin-right 8px
}
</style>
